import { router } from "@inertiajs/vue3";
import { useConnectionActions } from "~vue/composables/useConnectionActions";
import { ref } from "vue";

export function usePairPerspectiveDiscussion(connection: () => { id: string }) {
    const { startChat } = useConnectionActions();
    const isStartingChat = ref(false);
    const chatError = ref<string | null>(null);

    async function discuss(message: string) {
        if (isStartingChat.value) {
            return;
        }
        isStartingChat.value = true;
        chatError.value = null;
        try {
            const url = await startChat(connection(), { message, logSource: "pair_perspective" });
            if (!url) {
                throw new Error("No chat redirect");
            }
            await new Promise<void>((resolve, reject) => {
                router.visit(url, {
                    onSuccess: () => resolve(),
                    onError: () => reject(new Error("Chat navigation failed")),
                    onCancel: () => reject(new Error("Chat navigation canceled")),
                    onFinish: () => reject(new Error("Chat navigation did not complete")),
                });
            });
        } catch {
            chatError.value = "Your chat could not be opened. Please try again.";
        } finally {
            isStartingChat.value = false;
        }
    }

    return { discuss, isStartingChat, chatError };
}
